"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonSelect_1 = require("./Components/CommonSelect");
const Bancos_1 = require("./Components/Bancos");
const CategoriasCNH_1 = require("./Components/CategoriasCNH");
const Cidades_1 = require("./Components/Cidades");
const Estados_1 = require("./Components/Estados");
const EstadosCivis_1 = require("./Components/EstadosCivis");
const Generos_1 = require("./Components/Generos");
const GrausInstrucao_1 = require("./Components/GrausInstrucao");
const Nacionalidades_1 = require("./Components/Nacionalidades");
const Racas_1 = require("./Components/Racas");
const UnidadesMedida_1 = require("./Components/UnidadesMedida");
exports.default = {
    CommonSelect: CommonSelect_1.CommonSelect,
    Bancos: Bancos_1.Bancos,
    CategoriasCNH: CategoriasCNH_1.CategoriasCNH,
    Cidades: Cidades_1.Cidades,
    Estados: Estados_1.Estados,
    EstadosCivis: EstadosCivis_1.EstadosCivis,
    Generos: Generos_1.Generos,
    GrausInstrucao: GrausInstrucao_1.GrausInstrucao,
    Nacionalidades: Nacionalidades_1.Nacionalidades,
    Racas: Racas_1.Racas,
    UnidadesMedida: UnidadesMedida_1.UnidadesMedida,
};
